import { defineStore } from 'pinia'
import clinicalAssistService from '@/services/clinicalAssist.service'

export const useTokenBalanceStore = defineStore({
  id: 'tokenBalance',

  state: () => ({
    free: 0,
    purchased: 0,
    total: 0,
    quota: 0,
    unlimited: false,
    lastUsed: 0,
    loaded: false,
  }),

  getters: {
    hasTokens: state => state.unlimited || state.total > 0,

    usagePercent: state => {
      if (state.unlimited || state.quota <= 0) return 0
      return Math.round(((state.quota - state.free) / state.quota) * 100)
    },
  },

  actions: {
    updateFromHeaders(headers) {
      const free = headers['x-token-free']
      const purchased = headers['x-token-purchased']
      const total = headers['x-token-total']
      const quota = headers['x-token-quota']
      const used = headers['x-token-used']

      if (free !== undefined) this.free = parseInt(free, 10)
      if (purchased !== undefined) this.purchased = parseInt(purchased, 10)
      if (total !== undefined) this.total = parseInt(total, 10)
      if (quota !== undefined) this.quota = parseInt(quota, 10)
      if (used !== undefined) this.lastUsed = parseInt(used, 10)

      // -1 total means unlimited
      this.unlimited = this.total === -1
    },

    setBalance(data) {
      if (!data) return
      this.free = data.free ?? 0
      this.purchased = data.purchased ?? 0
      this.total = data.total ?? 0
      this.quota = data.quota ?? 0
      this.unlimited = data.unlimited ?? false
    },

    async fetchBalance() {
      try {
        const { data } = await clinicalAssistService.getCredits()
        this.setBalance(data.data)
        this.loaded = true
      } catch {
        // Silently fail — balance will update on next AI call via headers
      }
    },
  },
})
